import { useAppDispatch, useAppSelector } from "@app/hooks"
import { hide } from "./slice/MakeEventSlice"
import { selectDialog } from "./slice/selectors"
import QuickCreateEvent from "@components/QuickCreateEvent"

// Все кнопки «Создать событие» (шапка, лента, карта, плавающая) открывают
// один и тот же быстрый диалог. Старый пошаговый мастер (./layout) оставлен
// в коде на случай отката, но больше не показывается.
const MakeEvent = () => {
  const showDialog = useAppSelector(selectDialog)
  const dispatch = useAppDispatch()
  const handlerClose = () => {
    dispatch(hide())
  }

  return showDialog ? <QuickCreateEvent onClose={handlerClose} /> : null
}

export default MakeEvent
